import { render } from "./ClothCards.vue?vue&type=template&id=57a8fae8"
import script from "./ClothCards.vue?vue&type=script&lang=js"
export * from "./ClothCards.vue?vue&type=script&lang=js"

import "./ClothCards.vue?vue&type=style&index=0&id=57a8fae8&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__